import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button, Text } from '@beef/ui-kit';
import { I18n } from 'components';

const DeleteButton = ({ handleDeleteBtnClick }) => (
  <Button variant="plain" onClick={handleDeleteBtnClick}>
    <Text size="size5-m">
      <I18n path="family.ctnSetupTexts.removeBtnText" />
    </Text>
  </Button>
);

DeleteButton.propTypes = {
  handleDeleteBtnClick: PropTypes.func,
};

export { DeleteButton };
